import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { PERSONAS_TABLE_ACTIONS } from "../../PersonasHeader/enum";
import { baseResources, baseResourceActions } from "routes/enum";

const { AGENTS_INBOX_SERVICE_SETTING } = baseResources;
const { UPDATE, DELETE } = baseResourceActions;

const PersonasDropdown = ({ persona, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, persona)}
            options={[
                {
                    value: PERSONAS_TABLE_ACTIONS.EDIT,
                    label: "Edit",
                    baseResources: [
                        `${UPDATE}_${AGENTS_INBOX_SERVICE_SETTING}`,
                    ],
                },
                {
                    value: PERSONAS_TABLE_ACTIONS.DELETE,
                    label: "Delete",
                    baseResources: [
                        `${DELETE}_${AGENTS_INBOX_SERVICE_SETTING}`,
                    ],
                },
            ]}
        />
    );
};

export default PersonasDropdown;
